import React from 'react';
import { useLinesContext } from '../../../contexts/Lines';
import { Color } from '../../../themes/styles';
import theme from '../../../themes/CBB/theme';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: any) => ({
  emptyLine: {
    width: '100%',
    borderRadius: theme.spacing(1),
    height: 40,
    backgroundColor: theme.palette.brand.greyMid,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    opacity: 0.9,
    '&:hover': {
      boxShadow: `2px 4px 8px 4px ${theme.palette.brand.blueGrey}`,
      opacity: 1,
      backgroundColor: theme.palette.brand.greyMid,
    },
  },
}));

export default function EmptyLine({ onClick = null, disabled }) {
  const classes = useStyles();
  const { isCreatingFirst3Lines } = useLinesContext();
  const creatingFirst3Lines = isCreatingFirst3Lines();
  const borderColor =
    creatingFirst3Lines && !disabled
      ? theme.palette.brand[Color.ORANGE_DARK]
      : theme.palette.brand[Color.GREY_WHITE];
  const img =
    creatingFirst3Lines && !disabled
      ? 'newLinePlusOrange.svg'
      : 'newLinePlus.svg';

  function handleClick() {
    if (onClick) {
      onClick();
    }
  }

  return (
    <Button
      className={classes.emptyLine}
      onClick={handleClick}
      style={{
        border: `1px solid ${borderColor}`,
      }}
      disabled={disabled}
    >
      <img src={`icons/${img}`} alt="" />
    </Button>
  );
}
